"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendContactRequest = exports.deleteVisitorSettings = exports.updateVisitorSettings = exports.getVisitorSettings = void 0;
var uuid_1 = require("uuid");
var errors_1 = require("../errors");
var NoWindowError_1 = require("../errors/NoWindowError");
var utils_1 = require("../utils");
/**
 * Helper to get the visitorId from the domain cookie.
 *
 * Since a visitor can open multiple subdomains of different Bemer partners,
 * the visitorId is stored in a cookie, not in localStorage to allow
 * the visitorId to be available across multiple subdomains.
 * - partnerABC.bemergroup.com
 * - partnerYXZ.bemergroup.com
 *
 * If there is no visitor id in the cookie, a new UUID will
 * be created and set in the cookie as new visitor id.
 */
var getVisitorId = function () {
    var _a, _b, _c;
    // Do nothing when SSR.
    if (typeof window === 'undefined') {
        throw new NoWindowError_1.NoWindowError();
    }
    var COOKIE_VISITOR_ID_KEY = 'visitorId';
    var visitorId = (_c = (_b = (_a = document === null || document === void 0 ? void 0 : document.cookie) === null || _a === void 0 ? void 0 : _a.split('; ')) === null || _b === void 0 ? void 0 : _b.find(function (row) { return row.startsWith("".concat(COOKIE_VISITOR_ID_KEY, "=")); })) === null || _c === void 0 ? void 0 : _c.split('=')[1];
    if (!visitorId) {
        visitorId = (0, uuid_1.v4)();
        var maxAgeInSeconds = 60 * 60 * 24 * 365; // one year.
        document.cookie = "".concat(COOKIE_VISITOR_ID_KEY, "=").concat(visitorId).concat((0, utils_1.getCookieDomain)(), ";max-age=").concat(maxAgeInSeconds, ";path=/;samesite=strict");
    }
    return visitorId;
};
/**
 * Fetches the visitor settings from the backend.
 */
var getVisitorSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, response, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(utils_1.API_ENDPOINTS.BEMER_MARKETING, "/v1/visitor/").concat(getVisitorId(), "/settings");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                data = _a.sent();
                if (!response) {
                    throw new errors_1.NoResponseReceivedError();
                }
                return [2 /*return*/, data];
            case 4:
                error_1 = _a.sent();
                return [2 /*return*/, {
                        locale: utils_1.defaultLocale.id,
                        partnerHandle: undefined,
                        error: true,
                    }];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.getVisitorSettings = getVisitorSettings;
/**
 * Helper to sent PATCH events to the backend to update visitor settings.
 * Can be used to change and to delete values.
 *
 * @param payload
 */
var sendPatchRequest = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var url, requestInit, response, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(utils_1.API_ENDPOINTS.BEMER_MARKETING, "/v1/visitor/").concat(getVisitorId(), "/settings");
                requestInit = {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url, requestInit)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                data = _a.sent();
                if (!response) {
                    throw new errors_1.NoResponseReceivedError();
                }
                return [2 /*return*/, data];
            case 4:
                error_2 = _a.sent();
                console.error(error_2);
                throw error_2;
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Updates properties of the visitor settings in the backend.
 *
 * @param updateData An object containing only the keys (+ new values) to update.
 */
var updateVisitorSettings = function (updateData) {
    if (Object.keys(updateData).length === 0) {
        throw new Error('No data to update the visitor settings given.');
    }
    if (updateData.partnerHandle === '') {
        throw new Error('partnerHandle can not be an empty string. To remove the partnerHandle, use deleteVisitorSettings(["partnerHandle"]) instead.');
    }
    var payload = {};
    if (updateData.locale) {
        payload.locale = { newValue: updateData.locale };
    }
    if (updateData.partnerHandle) {
        payload.partnerHandle = { newValue: updateData.partnerHandle };
    }
    if (Object.keys(payload).length === 0) {
        throw new Error('No data to update the visitor settings set.');
    }
    return sendPatchRequest(payload);
};
exports.updateVisitorSettings = updateVisitorSettings;
/**
 * Deletes properties of the visitor settings in the backend.
 *
 * @param keys The keys to delete.
 */
var deleteVisitorSettings = function (keys) {
    if (!keys || keys.length === 0) {
        throw new Error('No keys to delete in the visitor settings given.');
    }
    var payload = {};
    keys.forEach(function (key) {
        payload[key] = { newValue: null };
    });
    return sendPatchRequest(payload);
};
exports.deleteVisitorSettings = deleteVisitorSettings;
/**
 * Sends a send-contact-request request to the backend to send an e-mail with the given message.
 *
 * @param payload
 */
var sendContactRequest = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var url, requestInit, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(utils_1.API_ENDPOINTS.BEMER_MARKETING, "/v1/visitor/").concat(getVisitorId(), "/send-contact-request");
                requestInit = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                };
                return [4 /*yield*/, fetch(url, requestInit)];
            case 1:
                response = _a.sent();
                if (!response) {
                    throw new errors_1.NoResponseReceivedError();
                }
                if (response.status === utils_1.HttpStatusCode.BAD_REQUEST) {
                    throw new errors_1.BadRequestError(' Call PATCH /v1/visitor/{visitorId}/settings to link a partner first.');
                }
                if (response.status === utils_1.HttpStatusCode.UNPROCESSABLE_ENTITY) {
                    throw new Error('The partner handle linked to the visitor could not be resolved to a partner.');
                }
                if (response.status !== utils_1.HttpStatusCode.OK) {
                    throw new errors_1.UnknownError("Response status code is: ".concat(response.status));
                }
                return [2 /*return*/, true];
        }
    });
}); };
exports.sendContactRequest = sendContactRequest;
